import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Collapse from '@mui/material/Collapse';

function PageMessage({ pageMessage }){
  const location = useLocation();
  const timerRef = useRef(null);

  const [display, setDisplay] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');

  useEffect(() => {
    return () => {
      if(timerRef.current) {
        clearTimeout(timerRef.current);
      }
    }
  }, []);

  useEffect(() => {
    setDisplay(false);
  }, [location.pathname, location.search, location.hash]); 
  
  useEffect(() => {
    if(pageMessage.message) {
      if(timerRef.current) {
        clearTimeout(timerRef.current);
      }

      setMessage(pageMessage.message || '');
      setType(pageMessage.type || '');
      setDisplay(true);
    
      if(pageMessage.time !== 0) {
        timerRef.current = setTimeout(() => {
          setDisplay(false);
        }, pageMessage.time * 1000);
      }
    }
  }, [pageMessage]);

  return (
    <Collapse in={display}>
      <div id="PageMessage" className={`${type}`}>
        { message }
      </div>
    </Collapse>
  );
}

function mapStateToProps(state) {
  const { pageMessage } = state.appDisplay;
  return { pageMessage };
}

export default connect(mapStateToProps)(PageMessage);